import React, {Component} from 'react'
import PropTypes from 'prop-types'
import 'antd/lib/checkbox/style/index.css'
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap"
import Button from "reactstrap/es/Button";
import {getListSku} from "../../../services/api/apiSku"
import {Spin} from 'antd'
import store from 'store'
import classNames from 'classnames'

class StaticsProduceSkusPopup extends Component {
    constructor(props) {
        super(props)
        const {typeSku} = props
        this.state = {
            loading: false,
            error: '',
            search: '',
            listSkus: [],
            arraySellected: store.get('listSkuStatics') ? (typeSku === '3D' ? store.get('listSkuStatics').sku3D : store.get('listSkuStatics').sku2D) : []
        }
    }

    componentDidMount() {
        this._handleListSkus()
    }

    _handleChangeInput = (e) => {
        const {name, value} = e.target

        this.setState({
            [name]: value
        }, () => {
            if (this.timeout) clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
                this._handleListSkus()
            }, 350)
        })
    }

    _handleListSkus = async () => {
        try {
            const {search, arraySellected} = this.state
            const {typeSku, type, skus: type2D} = this.props
            const firstOpen = typeSku === "2D" ? type2D.includes('*') : type.includes('*')

            this.setState({
                loading: true
            })

            const payload = {
                limit: 1000,
                page: 1,
                procedure: typeSku,
                sort: "sku",
                name: search,
                skip_meta: false,
                select: ['procedure', 'sku'],
            }

            const {'data': respons} = await getListSku(payload)

            const {success, data, message} = respons

            if (!success) {
                return this.setState({
                    loading: false,
                    error: message
                })
            }

            const {items} = data

            const SkuID = items.map(item => {
                return {
                    sku: item.sku,
                    procedure: item.procedure
                }
            })

            if(store.get('listSkus') && store.get('listSkus').length > 0) {
                const oldSkus = store.get('listSkus')
                const oldSkusName = oldSkus.map(itemName => itemName.sku)
                const skuNew = SkuID.filter(itemSku => !oldSkusName.includes(itemSku.sku))
                const _skuNew = skuNew.map(itemN => itemN.sku)
                arraySellected.push(..._skuNew)
                if (skuNew.length > 0) {
                    const new3D = skuNew.filter(item3D => item3D.procedure === '3D')
                    const new2D = skuNew.filter(item2D => item2D.procedure === '2D')

                    const selected3D = store.get('listSkuStatics') ? store.get('listSkuStatics').sku3D : []
                    const selected2D = store.get('listSkuStatics') ? store.get('listSkuStatics').sku2D : []

                    const objSkuStatics = {
                        sku3D: new3D.length > 0 ? selected3D.concat(new3D.map(item3D => item3D.sku)) : selected3D,
                        sku2D: new2D.length > 0 ? selected2D.concat(new2D.map(item2D => item2D.sku)) : selected2D,
                    }
                    store.set('listSkuStatics', objSkuStatics)
                }
            }

            this.setState({
                loading: false,
                listSkus: items,
                arraySellected: firstOpen ? items.map(item => item.sku) : arraySellected
            }, () => {
                const skusLocal = store.get('listSkuStatics') ? (typeSku === '3D' ? store.get('listSkuStatics').sku3D : store.get('listSkuStatics').sku2D) : []
                if (skusLocal.length === 0) this._saveLocalStograde(items.map(item => item.sku))
            })
        } catch (e) {
            this.setState({
                error: e.message
            })
        }
    }

    _handleSelectAll = () => {
        const {listSkus} = this.state
        const arrSelected = listSkus.map(item => item.sku)
        this.setState({
            arraySellected: arrSelected
        })
    }

    _handleClearSelected = () => {
        this.setState({
            arraySellected: []
        })
    }

    _saveLocalStograde = (skus) => {
        const {typeSku, onChangeListSku} = this.props
        const selected3D = store.get('listSkuStatics') ? store.get('listSkuStatics').sku3D : []
        const selected2D = store.get('listSkuStatics') ? store.get('listSkuStatics').sku2D : []
        const objSkuStatics = {
            sku3D: typeSku === '3D' ? skus : selected3D,
            sku2D: typeSku === '2D' ? skus : selected2D
        }
        store.set('listSkuStatics', objSkuStatics)

        if (typeof onChangeListSku === 'function') {
            onChangeListSku(typeSku === '3D' ? 'type' : 'skus', typeSku === '3D' ? objSkuStatics.sku3D : objSkuStatics.sku2D)
        }
    }

    _handleSetLocal = () => {
        const {onToggleModal} = this.props
        const {arraySellected} = this.state

        this._saveLocalStograde(arraySellected)
        onToggleModal()
    }

    _onChangeCheckbox = (e) => {
        console.log(e.target.checked)
        const {arraySellected} = this.state

        if (e.target.checked) {
            arraySellected.push(e.target.value)
            this.setState({
                arraySellected: arraySellected
            })
        } else {
            arraySellected.splice(arraySellected.indexOf(e.target.value), 1)
            this.setState({
                arraySellected: arraySellected
            })
        }
    }

    render() {
        const {listSkus, arraySellected, loading, error} = this.state
        const {isOpen, onToggleModal, widthItem, typeSku} = this.props

        let cols = 6, widthModal = (250 + 8) * 6 + 80
        if (widthItem > 250 && widthItem <= 350) {
            cols = 5
            widthModal = (310 + 8) * 5 + 80
        } else if (widthItem > 350) {
            cols = 4
            widthModal = (400 + 8) * 4 + 80
        }

        return (
            <div className="StaticsProduceSkusPopup">
                <Modal isOpen={isOpen} className="SkusModal"
                       style={{maxWidth: widthModal}}
                >
                    <ModalHeader toggle={onToggleModal}>
                        Chọn SKU {typeSku}
                        <div className="SearchInput">
                            <input type="text" name="search" placeholder="Tìm kiếm" onChange={this._handleChangeInput}/>
                            <Button className="bg-primary ml-2">
                                Tìm kiếm
                            </Button>
                        </div>
                    </ModalHeader>
                    <ModalBody>
                        <div className={classNames(`cols${cols}`)}>
                            <Spin spinning={loading} tip='Đang tải...'>
                                {error && <div className="text-danger">{error}</div>}
                                <div className="WrapCheckbox">
                                    {
                                        listSkus.length > 0 && listSkus.map((item, index) => {
                                            return <div key={index} className="ItemCheckbox d-inline-block"
                                                        style={{width: widthItem}}>
                                                <input type="checkbox" checked={arraySellected.includes(item.sku)}
                                                       id={item.sku} value={item.sku}
                                                       onChange={this._onChangeCheckbox}/>
                                                <label htmlFor={item.sku}>{item.sku}</label>
                                            </div>
                                        })
                                    }
                                </div>
                            </Spin>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <div className="d-flex w-100 align-items-center justify-content-end">
                            <Button className="bg-danger" onClick={this._handleClearSelected}>
                                Bỏ chọn tất cả
                            </Button>
                            <Button className="bg-primary ml-2" onClick={this._handleSelectAll}>
                                Chọn tất cả
                            </Button>
                            <Button className="bg-success ml-2" onClick={this._handleSetLocal}>
                                Save
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

StaticsProduceSkusPopup.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onToggleModal: PropTypes.func.isRequired,
    type: PropTypes.array,
    skus: PropTypes.array
}

export default StaticsProduceSkusPopup